<template>
  <div class="regra-modal__secao">
    <div class="regra-modal__secao-titulo">Query SQL</div>
    <div class="regra-modal__aviso">
      <fa-icon icon="info-circle" class="regra-modal__aviso-icone" />
      <span>
        O pedido é <strong>barrado</strong> quando a consulta retorna alguma linha, e o resultado vira a mensagem exibida.
        Valores nulos são ignorados, várias linhas são agrupadas e várias colunas aparecem separadas por vírgula.
        Use as variáveis com <code>:</code> para filtrar pelo pedido, cliente e usuário em validação.
      </span>
    </div>

    <label class="regra-modal__rotulo">Local de execução da query *</label>
    <div class="regra-negocio-query__bancos">
      <SeletorBusca
        :value="bancoAtual"
        :opcoes="bancos"
        :mostrar-codigo="false"
        :clearable="false"
        placeholder="Selecione onde a consulta será executada"
        aria-label="Local de execução da query"
        @change="changeBancoParaExecutar"
      >
        <template #prefixo="{ opcao }">
          <fa-icon :icon="opcao.icone || 'database'" />
        </template>
        <template #opcao="{ opcao }">
          <span class="regra-modal__opcao">
            <span class="regra-modal__opcao-icone"><fa-icon :icon="opcao.icone" /></span>
            <span class="regra-modal__opcao-texto">
              <strong>{{ opcao.descricao }}</strong>
              <small>{{ opcao.resumo }}</small>
            </span>
          </span>
        </template>
      </SeletorBusca>
    </div>
    <small v-if="erros['querySQL.banco']" class="regra-modal__campo-erro">{{ erros["querySQL.banco"] }}</small>

    <div class="regra-negocio-query__area">
      <div class="regra-negocio-query__editor">
        <label class="regra-modal__rotulo">Consulta *</label>
        <div class="regra-negocio-query__editor-caixa">
          <SqlEditor ref="editor" v-model="currentScript" :sugestoes="sugestoes" :executavel="false" />
        </div>
        <small v-if="erros['querySQL.query']" class="regra-modal__campo-erro">{{ erros["querySQL.query"] }}</small>
        <small v-else class="regra-modal__dica">
          Digite <code>:</code> ou pressione Ctrl+Espaço para sugerir variáveis. Ctrl+Alt+L formata a consulta e F11 abre em tela cheia.
        </small>
      </div>
      <div class="regra-negocio-query__binds">
        <label class="regra-modal__rotulo">Variáveis disponíveis</label>
        <BindsList :binds="binds" :carregando="carregandoBinds" @inserir="inserirBind" />
      </div>
    </div>
  </div>
</template>

<script>
import SqlEditor from "@/components/form/SqlEditor.vue";
import SeletorBusca from "@/components/form/SeletorBusca.vue";
import BindsList from "./BindsList.vue";
import { get } from "@/helpers/apiRequest";
import { BANCOS_QUERY } from "../../../constantes";

// DESABILITADO POR MOTIVOS DE SEGURANÇA
// const basePhpScript = '<?php\n\n'
const baseSqlScript = "SELECT * FROM V_BDTI WHERE :AUTH :ABC";

const DETALHES_BANCO = {
  LOCAL: { icone: "database", resumo: "Consulta as tabelas da plataforma Versotech" },
  ERP: { icone: "plug", resumo: "Consulta direto no banco do ERP integrado" },
};

export default {
  name: "QuerySql",
  components: { SqlEditor, SeletorBusca, BindsList },

  props: {
    item: { type: Object, required: true },
    erros: { type: Object, default: () => ({}) },
  },

  data() {
    return {
      tempScripts: {
        sql: null,
      },
      binds: [],
      carregandoBinds: false,
      bancos: Object.keys(BANCOS_QUERY).map((chave) => ({ id: chave, descricao: BANCOS_QUERY[chave], busca: DETALHES_BANCO[chave].resumo, ...DETALHES_BANCO[chave] })),
    };
  },

  computed: {
    bancoAtual() {
      return this.item.querySQL ? this.item.querySQL.banco : null;
    },

    sugestoes() {
      return this.binds.map((bind) => ({ texto: bind.bind, descricao: bind.descricao }));
    },

    currentScript: {
      get() {
        // DESABILITADO POR MOTIVOS DE SEGURANÇA
        // if (this.item.tipo === 'SP') {
        //   return this.item.scriptPHP.script || this.tempScripts.php || basePhpScript;
        // } 
        const query = this.item.querySQL ? this.item.querySQL.query : null;
        const digitado = this.tempScripts.sql;

        if (digitado !== null && (query === null ? digitado.trim() === baseSqlScript.trim() : query === digitado)) {
          return digitado;
        }

        return query || baseSqlScript;
      },
      set(value) {
        // DESABILITADO POR MOTIVOS DE SEGURANÇA
        // if (this.item.tipo === 'SP' && this.item.scriptPHP.script === undefined) {
        //   this.$set(this.item, 'scriptPHP', { script: null });
        // }

        if (!this.item.querySQL) {
          this.$set(this.item, "querySQL", { query: null, banco: null });
        }

        const isBaseScript = value.trim() === baseSqlScript.trim();
        // DESABILITADO POR MOTIVOS DE SEGURANÇA
        // if (isPhpType) {
        //   this.item.scriptPHP.script = isBaseScript ? null : value;
        //   this.tempScripts.php = isBaseScript ? null : value;
        // }

        this.item.querySQL.query = isBaseScript ? null : value;
        this.tempScripts.sql = value;
      },
    },
  },

  methods: {
    changeBancoParaExecutar(banco) {
      if (!this.item.querySQL) {
        this.$set(this.item, "querySQL", { query: null, banco: null });
      }

      this.item.querySQL.banco = banco;
    },

    loadBinds() {
      this.carregandoBinds = true;
      get("/admin/regras-negocio/binds")
        .then((json) => {
          this.binds = Array.isArray(json) ? json : [];
        })
        .catch(() => {
          this.binds = [];
        })
        .finally(() => {
          this.carregandoBinds = false;
        });
    },

    inserirBind(bind) {
      if (this.$refs.editor) this.$refs.editor.inserirNoCursor(bind);
    },
  },

  beforeMount() {
    this.loadBinds();
  },
};
</script>

<style scoped src="@/components/regras/regra-modal.css"></style>

<style scoped>
.regra-negocio-query__bancos {
  max-width: 520px;
}

.regra-negocio-query__area {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 300px;
  gap: 16px;
  margin-top: 16px;
}

.regra-negocio-query__editor,
.regra-negocio-query__binds {
  display: flex;
  flex-direction: column;
  min-width: 0;
}

.regra-negocio-query__editor-caixa {
  height: 420px;
}

.regra-negocio-query__binds >>> .regra-modal__caixa {
  height: 420px;
}

@media (max-width: 991.98px) {
  .regra-negocio-query__area {
    grid-template-columns: minmax(0, 1fr);
  }

  .regra-negocio-query__editor-caixa {
    height: 340px;
  }

  .regra-negocio-query__binds >>> .regra-modal__caixa {
    height: 300px;
  }
}
</style>
